import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Mixin from 'components/common/Mixin'
import Theme from 'components/common/Theme/Theme'
import { A } from 'components/common/Link/Link'
import Icon from 'components/common/Icon/Icon'
import kebabCase from 'lodash/kebabCase'
import { dynamicDataAttribute } from 'helpers/utils'

const PromoBlock = ({
  className,
  name,
  promotions = [],
  showPromotionModal,
  removeCouponActionHandler,
  noEdit,
  ...props
}) =>
  <Wrapper { ...dynamicDataAttribute(kebabCase(name)) } className={ className } { ...props }>
    <Name { ...dynamicDataAttribute(`${kebabCase(name)}-name`) }>{ name }</Name>
    {
      promotions.map(({ promotionName, promotionId, isUserAppliedPromotion, couponCode, adjustmentAmount }, index) =>
        <LinkWrapper key={ `${promotionId}-${couponCode}` }>
          <PromoIcon asset="money-promo" alt="" />
          <Link { ...dynamicDataAttribute(`${kebabCase(name)}-link`) } key={ index } prevent bolder to="/" handler={ showPromotionModal(promotionId) }>
            { isUserAppliedPromotion ? couponCode : promotionName }
            <Adjustment>(-${ Math.abs(adjustmentAmount).toFixed(2) })</Adjustment>
          </Link>
          {
            !noEdit && isUserAppliedPromotion &&
            <CloseIcon asset="icon-circle-close" onClick={ () => removeCouponActionHandler(couponCode) } />
          }
        </LinkWrapper>
      )
    }
  </Wrapper>

PromoBlock.propTypes = {
  atId: PropTypes.string,
  className: PropTypes.string,
  name: PropTypes.string,
  noEdit: PropTypes.bool,
  promotions: PropTypes.arrayOf(PropTypes.shape()),
  removeCouponActionHandler: PropTypes.func,
  showPromotionModal: PropTypes.func
}

export default PromoBlock

const Wrapper = styled.div`
  margin-top: 15px;
  padding: 10px 15px;
  border: 1px solid ${Theme.colors.light_grey};
`

const Name = styled.div`
  margin-bottom: 6px;
  ${Mixin.font.GothamBold()}
  line-height: 19px;
  color: ${Theme.colors.sub_grey};
`

const Link = styled(A)`
  & + & {
    padding-top: 10px;
  }

  display: block;
  width: 90%;
  position: relative;
  line-height: 24px;
  left: 26px;
`

const LinkWrapper = styled.div`
  position: relative;
  padding: 5px 0;
`

const PromoIcon = styled(Icon)`
  position: absolute;
  width: 18px;
  height: 18px;
  margin-right: 6px;
  float: left;
`

const CloseIcon = styled(Icon)`
  position: absolute;
  right: 0;
  bottom: 4px;
  width: 16px;
  height: 16px;
  cursor: pointer;
`

const Adjustment = styled.span`
  color: ${Theme.colors.black_new};
  margin-left: 5px;

  && {
    display: inline-block;
    text-decoration: none;
    cursor: auto;
  }
`
